export enum MdrServiceFlavor {
  FOUNDATIONS = 1,
  PREMIUM = 2,
  ENTERPRISE = 3,
  FOUNDATIONS_LEGACY = 4,
  BITDEFENDER_MDR = 11,
  BITDEFENDER_MDR_PLUS = 12
}
